import { useIFrameContext } from './IFrameContext';
import { isSSR } from './utils';

const MOBILE_SCREEN_WIDTH = 700;

export function useIsMobileView() {
  const isIFrame = useIFrameContext();
  if (isSSR()) {
    return Boolean(isIFrame);
  }

  const isMobile =
    (typeof window.visualViewport !== 'undefined'
      ? window.visualViewport.width
      : window.screen.availWidth) <= MOBILE_SCREEN_WIDTH;
  return isIFrame || isMobile;
}
